import {
  CanGoOutAloneCondition,
  CanGoOutAloneConditionInput
} from '../../lib/types/models/can-go-out-alone-condition/can-go-out-alone-condition'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateCanGoOutAloneCondition({
  id,
  ...rest
}: UpdateInput<CanGoOutAloneConditionInput>) {
  return restApiClient
    .url(constructApiUrl(API.canGoOutAloneCondition.update.url, { id }))
    .patch<CanGoOutAloneCondition, Partial<CanGoOutAloneConditionInput>>(rest)
}
